// Another user's newest public rankings for their profile (first page only).
// The API applies the profile's own privacy rule, so a private profile — or a
// failed request — just means "nothing to show": the section stays hidden.
// Re-fetched whenever the profile is opened, so visibility changes and
// deletions by the owner are picked up on the next visit.
import { useEffect, useState } from 'react';
import { RankingService } from '../../services/rankingService';

/** Rankings shown on a profile before "See All". */
export const PROFILE_RANKINGS_LIMIT = 3;

/** → { items: undefined (loading) | null (hidden) | array, hasMore } */
export default function useProfileRankings(username, { enabled = true } = {}) {
    const [state, setState] = useState({ items: undefined, hasMore: false });
    useEffect(() => {
        if (!username || !enabled) {
            setState({ items: null, hasMore: false });
            return undefined;
        }
        let alive = true;
        setState({ items: undefined, hasMore: false });
        RankingService.listForUser(username, { limit: PROFILE_RANKINGS_LIMIT })
            .then((page) => {
                if (!alive) return;
                setState(page?.isPrivate ? { items: null, hasMore: false } : { items: page?.items ?? [], hasMore: Boolean(page?.hasMore) });
            })
            .catch(() => alive && setState({ items: null, hasMore: false }));
        return () => { alive = false; };
    }, [username, enabled]);
    return state;
}
